import { UnitAvailabilityTypes } from '../sections/locationPage';

export const getImageType = (
  data: UnitAvailabilityTypes.TData,
  media?: any,
  defaultMedia?: any
) => {
  return data.customArt.show === undefined ? media : defaultMedia;
};
